export const pkg = {
  name: 'isomorphic-git',
  version: '1.7.4',
  agent: 'git/isomorphic-git@1.7.4',
}
